__turbopack_context__.v({
  "animatedPlaceholder": "AnimatedPlaceholder-module__pXDQTa__animatedPlaceholder",
  "dynamicText": "AnimatedPlaceholder-module__pXDQTa__dynamicText",
  "dynamicTextContainer": "AnimatedPlaceholder-module__pXDQTa__dynamicTextContainer",
  "staticText": "AnimatedPlaceholder-module__pXDQTa__staticText",
  "transitioning": "AnimatedPlaceholder-module__pXDQTa__transitioning",
});
